import React, { useState, useEffect } from "react";
import { Modal, Tabs, Tab } from "react-bootstrap";
import { ActionHandlerFunction, CollectionServerUser, EmailGroup } from "@preveil-api";
import { Account, AdminUIActionTypes, tab_event_key } from "src/common";
import { AliasForm, GroupForm, IndividualForm } from "..";

type AllProps = {
  current_account: Account;
  show_modal: boolean;
  selected_group?: EmailGroup;
  aliases: string[];
  org_users: CollectionServerUser[];
  is_update_mode?: boolean;
  handleAction: ActionHandlerFunction;
}

// Description: CreateEmailGroupModalComponent is a React component that renders a modal for creating, updating or copying user groups.
function CreateEmailGroupModalComponent(props: AllProps) {
  const { show_modal, selected_group, org_users, current_account, is_update_mode, handleAction, aliases } = props;
  const submit_button_label = `${!!is_update_mode ? "Update" : "Create"} User Group Email`;
  const [group_alias, setGroupAlias] = useState<string>(!!selected_group ? selected_group.alias : "");
  const [tab_heading, setTabHeading] = useState<string>(tab_event_key.enter_users);
  const [is_valid, setIsValid] = useState<boolean>(false);
  const [invalid_alias, setInvalidAlias] = useState<boolean>(false);
  const valid_group_users: string[] = [];

  useEffect(() => {
    !!selected_group && setGroupAlias(selected_group?.alias);
  }, [selected_group]);

  function handleTabSelect(event_key: string | null) {
    const tab_heading = event_key === "csv_upload" ? tab_event_key.csv_upload : tab_event_key.enter_users;
    setTabHeading(tab_heading);
  }

  function handleShowModal() {
    setGroupAlias("");
    setTabHeading(tab_event_key.enter_users);
    setIsValid(false);
    setInvalidAlias(false);
    handleAction({ actionType: AdminUIActionTypes.ShowModal });
  }

  return <Modal
    size="lg"
    show={show_modal}
    onHide={handleShowModal}
    aria-labelledby="create user group"
    centered>
    <Modal.Header closeButton>
      <Modal.Title>{!!is_update_mode ? `${submit_button_label} ${!!selected_group && `: ${selected_group?.alias}`}` : tab_heading}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <AliasForm
        is_edit={!is_update_mode}
        group_alias={group_alias}
        setGroupAlias={setGroupAlias}
        setInvalidAlias={setInvalidAlias}
        aliases={aliases} />
      <Tabs className="pt-2" defaultActiveKey="enter_users" id="create-email-group" onSelect={handleTabSelect}>
        <Tab eventKey="enter_users" title="Enter Users">
          <IndividualForm selected_group={selected_group} is_update_mode={is_update_mode} current_account={current_account} invalid_alias={invalid_alias} setIsValid={setIsValid} is_valid={is_valid} valid_group_users={valid_group_users} org_users={org_users} group_alias={group_alias} setGroupAlias={setGroupAlias} handleAction={handleAction} />
        </Tab>
        <Tab eventKey="csv_upload" title="CSV Upload">
          <GroupForm selected_group={selected_group} is_update_mode={is_update_mode} is_valid={is_valid} valid_group_users={valid_group_users} org_users={org_users} handleAction={handleAction} aliases={aliases} group_alias={group_alias} setGroupAlias={setGroupAlias} />
        </Tab>
      </Tabs>
    </Modal.Body>
  </Modal>;
}

export default React.memo(CreateEmailGroupModalComponent);
